var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"clear":"both"}},_vm._l((_vm.coachinglist),function(coaching,index){return _c('div',{key:coaching.rowKey},[_c('coaching',{attrs:{"coaching":coaching,"user":_vm.user,"even":index % 2 === 0}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }